import { useEffect, useState } from "react";
import { auth, db } from "../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined);
  const [userData, setUserData] = useState(undefined); // 🔥 importante

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      setUser(u);

      if (u) {
        const docSnap = await getDoc(doc(db, "users", u.uid));
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          setUserData(null);
        }
      } else {
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // ⛔ esperar TODO antes de decidir
  if (
    user === undefined ||
    userData === undefined
  ) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          color: "white"
        }}
      >
        <img
          src="/logo512sinfondo.png"
          alt="RNutricion"
          style={{
            width: "120px",
            height: "120px",
            objectFit: "contain",
            animation:
              "spin 4s linear infinite"
          }}
        />
  
        <p
          style={{
            marginTop: "20px",
            fontSize: "18px",
            fontWeight: 500,
            opacity: 0.9
          }}
        >
          Cargando RNutricion...
        </p>
  
        <style>
          {`
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/" />;
  
  // 🔥 PRIMERO validar rol (ANTES de todo)
  if (userData?.role === "nutricionista") {
    return children;
  }
  
  // 🔥 DESPUÉS verificación (solo pacientes)
  if (!user.emailVerified) {
    return <Navigate to="/verificar-email" />;
  }
  
  return children;
}

export default ProtectedRoute;